import { render } from "./drag-icon.vue?vue&type=template&id=473e5ef4"
import script from "./drag-icon.vue?vue&type=script&lang=ts"
export * from "./drag-icon.vue?vue&type=script&lang=ts"
script.render = render

export default script